type LogLevel = 'debug' | 'info' | 'warn' | 'error'

declare global {
  interface Console {
    dev: (...args: any[]) => void
    stage: (...args: any[]) => void
    prod: (...args: any[]) => void
    devGroup: (label: string, ...args: any[]) => void
  }
}

const createConsoleExtension = () => {
  const env = process.env.NEXT_PUBLIC_BUILD_ENV
  const isDevelopment = env === 'development'
  const isStaging = env === 'staging'
  const isProduction = env === 'production'

  const styledLog = (level: LogLevel, prefix: string, color: string, ...args: any[]) => {
    console.log(`%c${prefix}`, `color: ${color}; font-weight: bold`, ...args)
  }

  // Расширяем console
  ;(console as any).dev = (...args: any[]) => {
    if (isDevelopment || isStaging) {
      styledLog('debug', '[DEV]', '#4CAF50', ...args)
    }
  }
  ;(console as any).stage = (...args: any[]) => {
    if (!isProduction) {
      styledLog('info', '[STAGE]', '#FF9800', ...args)
    }
  }
  ;(console as any).prod = (...args: any[]) => {
    if (isProduction) {
      styledLog('info', '[PROD]', '#FF5722', ...args)
    }
  }

  // Группировка для dev логов
  ;(console as any).devGroup = (label: string, ...args: any[]) => {
    if (isDevelopment || isStaging) {
      console.groupCollapsed(`%c[DEV] ${label}`, 'color: #4CAF50; font-weight: bold')
      args.forEach((arg) => console.log(arg))
      console.groupEnd()
    }
  }
}

export default createConsoleExtension
